/**
 * Logos de prensa — Gudslip home.
 * Marquee infinito robusto (mismo patrón que el ticker §3.4): rellena cada una
 * de las 2 listas repitiendo sus logos hasta superar el ancho del viewport, para
 * que el translateX(-50%) del CSS haga un bucle sin costura a cualquier anchura.
 */
(function () {
  'use strict';

  function fill(viewport) {
    var vw = viewport.clientWidth || window.innerWidth || 0;
    if (!vw) return;
    var lists = viewport.querySelectorAll('.gudslip-press__list');
    for (var i = 0; i < lists.length; i++) {
      var list = lists[i];
      if (list.dataset.base == null) list.dataset.base = list.innerHTML;
      list.innerHTML = list.dataset.base; // reset (por si es un resize)
      var guard = 0;
      while (list.scrollWidth < vw + 100 && guard < 40) {
        list.insertAdjacentHTML('beforeend', list.dataset.base);
        guard++;
      }
    }
  }

  function boot() {
    var marquees = document.querySelectorAll('[data-press-marquee]');
    for (var i = 0; i < marquees.length; i++) fill(marquees[i]);
  }

  var timer;
  function onResize() {
    clearTimeout(timer);
    timer = setTimeout(boot, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('load', boot);
  window.addEventListener('resize', onResize);
  document.addEventListener('shopify:section:load', boot);
})();
